import React from 'react';

const DisplayErrors = props => (
  <div className="btn-ctrl">
    <span className="display-errors__message">{props.message}</span>
  </div>
);

export default DisplayErrors;
